export interface IFiveStartCommentResults {
    centerId: number,
    centerAlias: string,
    surveyDate: string,
    surveyType: string,
    commendations: string,
    opportunities: string
}
